module.exports = __webpack_public_path__ + "img/content9-1.09414e07.webp";